import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import usePlatform from "../../../hooks/usePlatform"
import mobileCreateFunnelSample from "../../../assets/images/funnel/create_funnel_sample_mobile.png"
import createFunnelSample from "../../../assets/images/funnel/create_funnel_sample.png"
import mobileCreateFunnelSampleEn from "../../../assets/images/funnel/create_funnel_sample_mobile_en.png"
import createFunnelSampleEn from "../../../assets/images/funnel/create_funnel_sample_en.png"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#F9FAFB",
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      padding: "0 20px",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function CreateFunnelSample() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  // const { ref } = useScrollImpressionLog({
  //   message: "4. 비 개발자도 쉽게",
  //   eventKey: `homepage_funnel_section_4_impression`,
  // })
  return (
    <div className={classes.root}>
      {lang === "ko" ? (
        <div className={classes.wrapper}>{<img src={isMobile ? mobileCreateFunnelSample : createFunnelSample} />}</div>
      ) : (
        <div className={classes.wrapper}>
          {<img src={isMobile ? mobileCreateFunnelSampleEn : createFunnelSampleEn} />}
        </div>
      )}
    </div>
  )
}
